import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Grid } from '@mui/material';

import { Button, Loading, Pill } from 'Components';
import Preferences from 'Core/containers/Preferences';
import { NotificationManager } from 'Components/Notifications';

import {
    mapLandmarksVisibleGetLandmarkTags,
    getPreferences,
    mapLandmarkUpdatePreference
} from 'Redux/actions';

import styles from 'Assets/sass/core/vars.scss';
import './styles.scss';

const LandmarkVisibleTags = (props) => {
    const dispatch = useDispatch();
    const { intl } = props;
    const { messages } = intl;

    const preferencesRef = useRef();
    const [selectedLandmarkTags, setSelectedLandmarkTags] = useState([]);
    const [preferences, setPreferences] = useState();
    const preferencesKey = 'realtimeMaps';

    const { landmarkTags, landmarkTagsLoading } = useSelector((state) => state.realtimeMapLandmarkListModuleRedux);

    const contPreference = useSelector((state) => state.realtimeMapLanndmarkVisibleTagsAssignRedux.contPreference);
    const loadingPreference = useSelector(state => state.preferencesRedux.loadingPreference);
    const {
        user,
        authenticatedId,
    } = useSelector((state) => state.securityRedux);

    useEffect(()=> {
        dispatch(getPreferences({ entityName: "User", entityId: authenticatedId }));
    },[])

    useEffect(()=>{
        //update preferences
        if(contPreference > 0 && !loadingPreference){
            dispatch(getPreferences({ entityName: "User", entityId: authenticatedId }));
        }
    },[contPreference, loadingPreference])

    useEffect(() => {
        if (landmarkTags && landmarkTags.length && preferences?.hiddenLandmarkGroups) {
            initLandmarkTags(preferences?.hiddenLandmarkGroups);
        }
    }, [landmarkTags, preferences?.hiddenLandmarkGroups]);

    const onSelectLandmarkTag = useCallback((item) => {
        let newLandmarkTags = [...selectedLandmarkTags];
        if (item?.id === 0) {
            if (selectedLandmarkTags.length === landmarkTags.length) {
                newLandmarkTags = [];
            } else {
                newLandmarkTags = [...landmarkTags];
            }
        } else {
            if (newLandmarkTags.find(tag => tag.id === item.id)) {
                newLandmarkTags = selectedLandmarkTags.filter(tag => tag.id !== item.id);
            } else {
                newLandmarkTags.push(item);
            }
        }

        setSelectedLandmarkTags(newLandmarkTags);
    });

    const save = useCallback(() => {
        if (authenticatedId) {
            let ids = selectedLandmarkTags.map(tag => {
                return tag.id;
            });

            let newHiddenLandmarkTags = landmarkTags.filter(tag => !ids.includes(tag.id));
            const newPreferences = {
                ...preferences,
                hiddenLandmarkGroups: newHiddenLandmarkTags.map(hiddenLandmarkTag => {
                    return hiddenLandmarkTag.id;
                })
            }
            setPreferences(newPreferences)
            preferencesRef?.current?.savePreference("User", preferencesKey, newPreferences)
        }

        NotificationManager.success(
            messages['mapLandmarkVisibleLandmarkGroups_success'],
            messages['success'],
            3000,
            null,
            null,
            'warning',
        );

        //update the preferences for another modules
        dispatch(mapLandmarkUpdatePreference())
        
    });

    const initLandmarkTags = useCallback((hiddenLandmarkTags) => {
        let newSelectedLandmarkTags = landmarkTags.filter(tag => !hiddenLandmarkTags.includes(tag?.id));
        setSelectedLandmarkTags(newSelectedLandmarkTags);
    });

    const selectedStyle = {
        width: '100%',
        backgroundColor: styles.blue,
        color: "white",
        border: `1px solid ${styles.blue}`
    };

    const defaultStyle = {
        width: '100%',
        backgroundColor: "#F1F1F1",
        color: "#484848",
        border: "1px solid #F1F1F1"
    };

    return (
        <div className="landmark-visible-groups-container">
            <Preferences
                ref={preferencesRef}
                preferencesKey={preferencesKey}
                onInitialPreferences={(paramPreferences) => {
                    dispatch(mapLandmarksVisibleGetLandmarkTags());
                    if(!preferences){
                        setPreferences(paramPreferences);
                    }
                }}
            >
                {
                    landmarkTagsLoading ?
                        <div style={{ padding: 20 }}><Loading full /></div> :
                        <div
                            style={{
                                height: "calc(100vh - 360px)",
                                overflow: "hidden auto"
                            }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                spacing={1}

                            >
                                <Grid item xs={6}>
                                    <Pill
                                        item={{ id: 0, name: selectedLandmarkTags?.length === landmarkTags?.length ? messages['mapLandmarkVisibleLandmarkGroups_unselectAll'] : messages['mapLandmarkVisibleLandmarkGroups_selectAll'] }}
                                        style={defaultStyle}
                                        outlined={false}
                                        onClick={(value) => {
                                            onSelectLandmarkTag(value);
                                        }}
                                    />
                                </Grid>

                                {
                                    landmarkTags.map((tag, index) => {
                                        let selected = selectedLandmarkTags.find(selectedLandmarkGroup => selectedLandmarkGroup.id === tag.id);
                                        return (
                                            <Grid item xs={6} key={index}>
                                                <Pill
                                                    item={tag}
                                                    outlined={false}
                                                    style={selected ? selectedStyle : defaultStyle}
                                                    onClick={(value) => {
                                                        onSelectLandmarkTag(value);
                                                    }}
                                                />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </div>
                }

            </Preferences>

            <div className="landmark-visible-groups-footer">
                <Button
                    disabled={false}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        initLandmarkTags(preferences?.hiddenLandmarkGroups);
                    }}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={!selectedLandmarkTags.length}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        save();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    )
}

export default injectIntl(LandmarkVisibleTags);